<ng-template>
  <!-- ICON -->
  <ng-container *ngIf="!IsNullOrUndefinedOrEmpty(icon)">
    <mat-icon [ngClass]="[sizeClass, iconClass]" [svgIcon]="icon"></mat-icon>
  </ng-container>

  <!-- CONTENT -->
  <span [ngClass]="[textClass]">{{ displayText }}</span>
</ng-template>